(function () {
  var SECTION_END = '__section_anlass_kGxMpQ';

  function findSectionRoot() {
    var byId = document.querySelector('[id$="' + SECTION_END + '"]');
    if (byId) return byId;
    return document.querySelector('.shopify-section[id$="' + SECTION_END + '"]');
  }

  function init() {
    var root = findSectionRoot();
    if (!root) return;

    var track = root.querySelector('.section-content-wrapper .layout-panel-flex--row');
    if (!track || track.dataset.anlassSliderInit === '1') return;

    var slides = track.children;
    if (slides.length < 2) return;

    track.dataset.anlassSliderInit = '1';

    var rowGroup = track.closest('.group-block');
    if (!rowGroup || !rowGroup.parentNode) return;

    var existingDots = root.querySelector('.anlass-slider-dots');
    if (existingDots) existingDots.remove();

    var nav = document.createElement('ul');
    nav.className = 'anlass-slider-dots';
    nav.setAttribute('role', 'tablist');
    nav.setAttribute('aria-label', 'Karussell');

    var buttons = [];

    for (var i = 0; i < slides.length; i++) {
      (function (index) {
        var li = document.createElement('li');
        li.setAttribute('role', 'presentation');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.setAttribute('aria-label', 'Folie ' + (index + 1) + ' von ' + slides.length);
        btn.setAttribute('aria-current', index === 0 ? 'true' : 'false');
        btn.addEventListener('click', function () {
          slides[index].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
        li.appendChild(btn);
        nav.appendChild(li);
        buttons.push(btn);
      })(i);
    }

    rowGroup.parentNode.insertBefore(nav, rowGroup.nextSibling);

    function syncDots() {
      var bestIdx = 0;
      if (slides.length > 0) {
        var slideW = slides[0].offsetWidth;
        var gap = 0;
        try {
          var g = window.getComputedStyle(track).gap;
          var parsed = parseFloat(g);
          if (!isNaN(parsed)) gap = parsed;
        } catch (e) {}
        var step = slideW + gap;
        if (step > 0) {
          bestIdx = Math.round(track.scrollLeft / step);
          bestIdx = Math.max(0, Math.min(slides.length - 1, bestIdx));
        }
      }

      for (var k = 0; k < buttons.length; k++) {
        buttons[k].setAttribute('aria-current', k === bestIdx ? 'true' : 'false');
        buttons[k].setAttribute(
          'aria-label',
          'Folie ' + (k + 1) + ' von ' + slides.length + (k === bestIdx ? ' (aktiv)' : '')
        );
      }
    }

    var scrollTimer;
    track.addEventListener(
      'scroll',
      function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(syncDots, 48);
      },
      { passive: true }
    );

    if ('onscrollend' in track) {
      track.addEventListener('scrollend', syncDots);
    }

    window.addEventListener(
      'resize',
      function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(syncDots, 100);
      },
      { passive: true }
    );

    if (window.ResizeObserver) {
      try {
        var ro = new ResizeObserver(function () {
          syncDots();
        });
        ro.observe(track);
      } catch (e) {}
    }

    syncDots();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (!ev.detail || !ev.detail.sectionId) return;
    if (ev.detail.sectionId.indexOf('section_anlass_kGxMpQ') === -1) return;
    var sec = document.querySelector('[id="shopify-section-' + ev.detail.sectionId + '"]');
    if (sec) {
      var tr = sec.querySelector('.layout-panel-flex--row');
      if (tr) delete tr.dataset.anlassSliderInit;
      sec.querySelectorAll('.anlass-slider-dots').forEach(function (el) {
        el.remove();
      });
    }
    requestAnimationFrame(init);
  });
})();
